import { Attestation } from "domain/entity/Attestation";

/**
 * A model with a parser to convert JSON into an Attestation
 */
export class AttestationModel extends Attestation {
  static fromJson = (json) =>
    new Attestation(json?.user_id, json?.attestation_date, json?.attested);
}
